
export class Agent_Mef {
    agent_matricule:number;
    agent_nom:any;
    agent_prenom:any;
    agent_photo : any;
    agent_departement:any;
    agent_direction:any;
    agent_service:any;
    agent_lieu : any;
    agent_cin:any;
    agent_dateNaissance : any;
    agent_sexe : any;
    date_deb_visiteur: any;
    date_sort_visiteur: any;

    
       
    constructor(agent_matricule:number){
           
    }
}
